import { Close, Search } from '@mui/icons-material';
import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from '@mui/material';
import Fuse from 'fuse.js';
import { ChangeEvent, useState } from 'react';
import { Snapshot } from 'types';
import { sortByName } from '../searchWidget/utils/searchUtils';

export const useSnapshotFilterBar = () => {
  const [searchText, setSearchText] = useState('');
  const handleSearchChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };
  const getFilterSnapshotsByName = (snapshotsToFilter: Snapshot[]) => {
    const snapshotSearch = new Fuse(snapshotsToFilter || [], {
      keys: ['name'],
      threshold: 0.25,
    });
    const filterSnapshotsByName = () =>
      !searchText
        ? snapshotsToFilter
        : snapshotSearch
            .search(searchText)
            .map((resultObject) => resultObject.item)
            .sort(sortByName);
    return filterSnapshotsByName;
  };

  const SnapshotFilterBar = (
    <FormControl
      sx={{
        m: 1,
        width: '27ch',
        '& :hover': {
          '& .endCloseIconHidden': {
            opacity: 1,
          },
        },
      }}
      variant='outlined'
    >
      <OutlinedInput
        value={searchText}
        sx={{
          pr: '.1rem',
          borderColor: 'white',
          color: 'white',
          '& *': {
            color: 'white',
            borderColor: (theme) =>
              theme.palette.mode === 'light' ? 'white !important' : undefined,
          },
          '& .endCloseIconHidden': {
            opacity: 0,
          },
        }}
        id='field1'
        onChange={handleSearchChanged}
        size={'small'}
        placeholder='Filter Snapshots'
        startAdornment={
          <InputAdornment position='start' color='inherit'>
            <Search />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment
            className={'endCloseIconHidden'}
            position='end'
            color='inherit'
          >
            <IconButton size='small' onClick={() => setSearchText('')}>
              <Close />
            </IconButton>
          </InputAdornment>
        }
        inputProps={{ autoComplete: 'off' }}
      />
    </FormControl>
  );
  return { SnapshotFilterBar, getFilterSnapshotsByName };
};
